// extracted by mini-css-extract-plugin
module.exports = {"formsActions":"ProjectErrorMessagesPage_formsActions__1D7tV","input":"ProjectErrorMessagesPage_input__7KlD5","inputWarningMsg":"ProjectErrorMessagesPage_inputWarningMsg__3frGw"};